var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__inner"},[_c('Icon',{attrs:{"height":_vm.size,"width":_vm.size}},[_c('IconLoop')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }